import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { ppsiPublishedRoute, ppsiInProgressRoute } from '../../../routes';
import { getPpsiById } from '../../../features/PpsiContainer/selectors';
import DataTypes from '../../Table/dataTypes';
import Table from '../../Table/Table';
import {
  EnrichmentData,
  States
} from '../../../features/PpsiContainer/constants';
import FormContext from '../../Form/FormContext';
import UpdatesIcon from '../../common/UpdatesIcon';

function getEnrichmentData(ppsi, enrichmentData) {
  const { id: ppsiId } = ppsi;
  return { ppsiId, ...enrichmentData };
}

function getPpsiVersions(ppsi) {
  const data = [];
  if (ppsi[EnrichmentData.IN_PROGRESS]) {
    data.push(getEnrichmentData(ppsi, ppsi[EnrichmentData.IN_PROGRESS]));
  }
  if (ppsi[EnrichmentData.PUBLISHED]) {
    data.push(getEnrichmentData(ppsi, ppsi[EnrichmentData.PUBLISHED]));
  }
  return data;
}

const VersionColumns = {
  PresentationName: {
    name: 'presentationName',
    label: 'Product Name',
    dataField: 'presentationName',
    translatable: true,
    link: rowData => {
      return rowData.status === States.PUBLISHED ||
        rowData.status === States.UNPUBLISHED
        ? ppsiPublishedRoute(rowData.ppsiId)
        : ppsiInProgressRoute(rowData.ppsiId);
    }
  },
  Status: {
    name: 'status',
    dataField: 'status',
    label: 'Status',
    width: 100
  },
  Version: {
    name: 'version',
    dataField: 'version',
    label: 'Version',
    width: 50
  },
  VersionComment: {
    name: 'versionComment',
    label: 'Version Comment',
    dataField: 'versionComment',
    translatable: true
  },
  ActualPublishDate: {
    name: 'actualPublishDate',
    dataField: `actualPublishedDate`,
    dataType: DataTypes.Date,
    label: 'Publishing Date',
    searchable: false,
    width: 150,
    grow: 0,
    shrink: 0
  },
  Updates: {
    name: 'updates',
    CellValue: ({ rowData }) => {
      const { upToDate, updateNotificationList } = rowData.data;
      return (
        !upToDate && (
          <UpdatesIcon
            rowData={rowData}
            message={updateNotificationList
              .map(notification => notification.message)
              .join(',')}
          />
        )
      );
    },
    label: 'Updates',
    width: 100,
    grow: 0,
    shrink: 0
  }
};
const VersionsTabContent = () => {
  const { data } = useContext(FormContext);
  const { ppsiId } = data;
  const ppsi = useSelector(getPpsiById(ppsiId)).toJS();
  const versions = getPpsiVersions(ppsi);

  return (
    <div style={{ height: '400px' }}>
      <Table
        title="ppsi.versionsTableHeader"
        data={versions}
        columns={[
          VersionColumns.PresentationName,
          VersionColumns.Status,
          VersionColumns.Version,
          VersionColumns.VersionComment,
          VersionColumns.ActualPublishDate,
          VersionColumns.Updates
        ]}
        getObjectId={object => object.id}
        defaultSorting={[{ columnName: 'version', direction: 'asc' }]}
        selectable={false}
        toolbarVisible={false}
      />
    </div>
  );
};

export default VersionsTabContent;
